import { SettingConst } from '../../types';

/**
 * Configuration setting to enable OwF grants program by country.
 */
export const OWF_GRANTS_BY_COUNTRY = 'OWF_GRANTS_BY_COUNTRY' as SettingConst<
  'OWF_GRANTS_BY_COUNTRY',
  boolean,
  'RETAILER'
>;
